import styled from "styled-components";

export const CountersContainer = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  justify-content: end;

  @media  (min-width: 100px) and (max-width: 390px)  {
    justify-content: center;
    gap: 0.5rem;
    flex-direction: column !important;
    width: 100%;
  }

  @media (max-width: 692px) {
    justify-content: center;
    gap: 0.5rem;
    flex-direction: row;
    width: 100%;
  }

  @media (max-width: 1434px) {
    gap: 0.5rem;
  }

  
`;

export const CounterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  border: 1px solid #E0E0E0;
  background-color: #FFFFFF;
  cursor: pointer;
  font-size: 1rem;

  &:hover {
    background-color: #F5F5F5;
  }
`;

export const CounterNumber = styled.span`
  font-size: 1.25rem;
  font-weight: bold;
`;

export const CounterLabel = styled.span`
  font-size: 0.875rem;
  color: #5F6368;
`;


export const UsedLicensesContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
  padding: .5em 1em;
  border-radius: .75em;
  background-color: #FFFFFF;

  @media (max-width: 1023px){
    justify-content: center;
    gap: 0.5rem;
    flex-direction: column;
    width: 100%;
  }


`;


export const LicensesInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const LicenseNumber = styled.p`
  font-size: 32px;
  font-weight: bold;
  margin: 0;
`;



export const AvailableLicenses = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
  background-color: #FFFFFF;
  padding: .5em 1em;
  border-radius: .75em;

   @media (max-width: 1023px){
    justify-content: center;
    gap: 0.5rem;
    flex-direction: column;
    width: 100%;
  }





`;

export const ParagraphContainer = styled.p`
  max-width: auto;
  margin: 0;
  font-size: 14px;


  @media (max-width: 1280px){
    max-width: 59px;
  }

`;
